import { render, staticRenderFns } from "./rawMaterialConsume.vue?vue&type=template&id=2e5d5aba&scoped=true"
import script from "./rawMaterialConsume.vue?vue&type=script&lang=js"
export * from "./rawMaterialConsume.vue?vue&type=script&lang=js"
import style0 from "./rawMaterialConsume.vue?vue&type=style&index=0&id=2e5d5aba&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d5aba",
  null
  
)

export default component.exports